import { Component, OnInit, TemplateRef } from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-toasts-container',
    host: { '[class.ngb-toasts]': 'true' },
    templateUrl: './toasts-container.component.html',
    styleUrls: ['./toasts-container.component.scss'],
    standalone: false
})
export class ToastsContainerComponent implements OnInit {

  constructor(public toastService: ToastService) { }

  isTemplate(toast) { return toast.textOrTpl instanceof TemplateRef; }

  ngOnInit(): void {
  }

}
